/**
 * Format a date/ISO string as MM/DD/YYYY.
 * Accepts: "2026-07-01" | "2026-07-01T14:22:11.123Z" | Date object | undefined.
 * Returns "—" when the input is empty or unparseable.
 */
export function formatDate(input) {
  if (!input) return "—";
  // Bare ISO date "YYYY-MM-DD" — build a Date at UTC noon to sidestep timezone rollbacks
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
    const [y, m, d] = input.split("-");
    return `${m}/${d}/${y}`;
  }
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d)) return "—";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}

/** MM/DD/YYYY · h:mm AM for compact timestamps (activity feed) */
export function formatDateTime(input) {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d)) return "—";
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return `${formatDate(d)} · ${time}`;
}
